import mapFunction from './mapResources';

export default mapFunction('approvals', {
    isFetching: false,
    items: [] 
});